import Chart from 'react-apexcharts';
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { Card, Col, Row, Spinner } from "react-bootstrap";
import DashboardRequestService from 'services/dashboard-request';

export default function TotalMonthlyRevenueRender({ fiscalYear }) {

  const data_default = useMemo(() => {
    let data = fiscalYear.programs.map((p) => {
      return {
        name: p.name,
        values: []
      }
    })

    return [...data, {
      name: "Outros",
      values: []
    }]
  }, [fiscalYear]);

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const ref = useRef(null);

  const getProps = useCallback(() => {
    if (ref && ref.current) {
      const current = ref.current;
      return {
        width: current.getBoundingClientRect().width - 30
      }
    }
    return {};
  }, [ref])

  const showNotData = useMemo(() => {
    return data.reduce((total, type) => {
      if (type.values.length == 0) return total;

      let v = type.values.reduce((total2, value) => {
        return total2 + value.value;
      }, 0);
      return total + v;
    }, 0) == 0;
  }, [data]);

  useEffect(() => {
    let filters = {
      sort_by: 'month',
      fiscal_year_id: fiscalYear.id,
    };

    setLoading(true);
    DashboardRequestService
      .getDataByMonth(filters)
      .then(({ data }) => {
        // console.log("Faturamento total mensal",data);
        setData(data)
        // set(data.data);
      }).finally(() => {
        setLoading(false)
      });
  }, [fiscalYear]);

  return (
    <Card.Body className="card-dashboard shadow bg-white rounded h-100 w-100" ref={ref}>
      <Row>
        <Col md="12">
          <span className="dashboard-card-h5 text-left">
            Faturamento total mensal
          </span>
        </Col>
        <Col md="12">
          <hr></hr>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="12">
          <Chart
            options={{
              chart: {
                type: 'area',
              },
              dataLabels: {
                enabled: false,
              },
              stroke: {
                curve: 'smooth',
              },
              xaxis: {
                type: 'datetime',
                categories: (loading?data_default:data).map((d)=>{
                  return d.values.map((v)=>{
                    return v.month;
                  })
                }),
                labels: {
                  format: 'MM/yyyy',
                },
              },
              yaxis: {
                labels: {
                  formatter: function (d) {
                    return d.toLocaleString("pt-br", {
                      style: 'currency',
                      currency: 'BRL'
                    })
                  },
                },
              },
              responsive: [
                {
                  breakpoint: 480,
                  options: {
                    yaxis: {
                      labels: {
                        formatter: function (d) {
                          return d
                        },
                      },
                    },
                  },
                },
              ],
              tooltip: {
                x: {
                  format: 'MM/yyyy',
                },
                y: {
                  enabled: false,
                },
              },
              animations: {
                enabled: true,
                easing: 'easeinout',
                speed: 800,
                animateGradually: {
                  enabled: true,
                  delay: 150,
                },
                dynamicAnimation: {
                  enabled: true,
                  speed: 350,
                },
              },
            }}
            series={
              (loading?data_default:data).map((a)=>{
                return {
                  name: a.name,
                  data: a.values.map((v)=>{
                    return {
                      x:new Date(v.month),
                      y:v.value
                    }
                  })
                };
              })
              // fiscalYear == 13 ? [
              //   {
              //     name: 'ScanSource Select',
              //     data: graphElitePass.map((v) => {
              //       return v.value;
              //     }),
              //   },
              //   {
              //     name: 'Outros',
              //     data: graphOthers.map((v) => {
              //       return v.value;
              //     }),
              //   },
              // ] : [
              //   {
              //     name: 'Elite',
              //     data: graphElite.map((v) => {
              //       return v.value;
              //     }),
              //   },
              //   {
              //     name: 'Elite Gerencial',
              //     data: graphEliteManager.map((v) => {
              //       return v.value;
              //     }),
              //   },
              //   {
              //     name: 'ScanCash',
              //     data: graphScancash.map((v) => {
              //       return v.value;
              //     }),
              //   },
              //   {
              //     name: 'ScanSource Select',
              //     data: graphElitePass.map((v) => {
              //       return v.value;
              //     }),
              //   },
              //   {
              //     name: 'Outros',
              //     data: graphOthers.map((v) => {
              //       return v.value;
              //     }),
              //   }
              // ]
            }
            type="area"
            {...getProps()}
          />
        </Col>
      </Row>
      <div style={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)"
      }}>
        {loading?(
          <Spinner animation="border" size="sm" />
        ):<>
          {!showNotData?<></>:<h6>Sem dados</h6>}
        </>}
      </div>
    </Card.Body>
  );
}